const customDecodeUri = require('./customDecodeUri')

/**
 * uses for escape(unescape(someString))
 * for just escape(someString) use encodeUri
 * @param  {string} str
 */
const customEncodeUri = (str) => {
  str = customDecodeUri(str)
  return encodeURI(str)
}

module.exports = customEncodeUri
